/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationState from 'store/application';
import { waitFor }      from 'utils/waitFor';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'g3w-map',

  data() {
    const { service } = this.$options;
    return {
      target:         this.$options.service.target,
      hidemaps:       service.state.hidemaps,
      map_info:       service.state.map_info,
      service,
      mouse: {
        visible:     true,
        switch_icon: false,
        epsg_4326:   false,
        tooltip:     null,
      },
      urlCopied: false,
      mapunit:   ApplicationState.map.unit,
    }
  },

  computed: {

    version() {
      return 'Powered by G3W-SUITE ' + initConfig.version;
    },

    showmapunits() {
      return this.service.state.mapunits.length > 1;
    },

  },

  methods: {

    /**
     * @since 3.11.0
     */
    onDrop(e) {
      document.querySelector('.drop-area').toggleAttribute('hidden', 'dragenter' !== e.type);
      if (e.dataTransfer.files && 'drop' === e.type) {
        const map = GUI.getService('map');
        const q = document.querySelector.bind(document);
        // set modal options
        const setOption = async (el, value) => {
          el = '#modal-addlayer ' + el;
          await waitFor(() => q(el), 1000);
          q(el).value = value;
          q(el).dispatchEvent(new Event('input'));
          q(el).dispatchEvent(new Event('change'));
        }
        const setFile = async (file) => {
          await waitFor(() => !q('#add-layer-type').value, 5000);
          if (map.getLayerByName(file.name)) {
            return console.assert(!map.getLayerByName(file.name), `Unable to add layer: ${file.name}`);
          }
          setTimeout(() => console.assert(map.getLayerByName(file.name), `Unable to add layer: ${file.name}`), 2500);
          await setOption('#add-layer-type', 'file');
          await waitFor(() => q('#addcustomlayer input[type="file"]'), 1000);
          const data = new DataTransfer();
          data.items.add(file);
          q('#addcustomlayer input[type="file"]').files = data.files;
          q('#addcustomlayer input[type="file"]').dispatchEvent(new Event('change'));
          $('#modal-addlayer').modal('show');
        }
        setFile(e.dataTransfer.files[0]);
      }
    },

    showEmbedModal() {
      document.querySelector('.nav-embedmap').click();
    },

    switchMapsCoordinateTo4326() {
      this.mouse.epsg_4326 = !this.mouse.epsg_4326;
      this.service.getMapControlByType('mouseposition').dispatchEvent({
        type: 'change:epsg',
        epsg: this.mouse.epsg_4326 ? 'EPSG:4326' : this.service.getEpsg(),
      })
    },

  },

  watch: {
    'mapunit'(unit) {
      ApplicationState.map.unit = unit;
      this.service.changeScaleLineUnit(unit);
    }
  },

  async mounted() {

    this.crs = this.service.getCrs();

    await this.$nextTick();

    // listen of after addHideMap
    this.service.onafter('addHideMap', async ({ratio, layers=[], mainview=false, switchable=false} = {}) => {
      await this.$nextTick();
      this.service._addHideMap({ratio, layers, mainview, switchable});
    });

    this.service.once('ready', () => {
      if (this.service.getMapControlByType('mouseposition')) {
        this.mouse.switch_icon = (
          this.service.getMapControlByType('mouseposition')
          && 'EPSG:4326' !== this.service.getEpsg()
        );
        this.mouse.tooltip = `ESPG ${this.service.getCrs().split(':')[1]} ↔ WGS84`;
      } else {
        this.mouse.visible = false;
      }
    });

  },

  destroyed() {
    this.service.clear();
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g3w-maps"}},[_vm._l((_vm.hidemaps),function(hidemap){return _c('div',{key:hidemap.id,staticClass:"g3w-map hidemap",attrs:{"id":hidemap.id}})}),_vm._v(" "),_c('div',{staticClass:"g3w-map",attrs:{"id":_vm.target},on:{"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)},"dragenter":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)},"dragleave":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"drop-area",attrs:{"hidden":""}},[_vm._v("\n      Upload Files\n    ")]),_vm._v(" "),_c('div',{ref:"g3w-map-controls",staticClass:"g3w-map-controls rv",staticStyle:{"display":"flex"}}),_vm._v(" "),(_vm.map_info.info)?_c('div',{ref:"g3w-map-info",style:(_vm.map_info.style),attrs:{"id":"g3w-map-info"}},[_vm._v("\n      "+_vm._s(_vm.map_info.info)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"g3w-map-controls-left-bottom"})]),_vm._v(" "),_c('div',{staticClass:"skin-border-color",attrs:{"id":"map_footer"}},[_c('div',{staticStyle:{"display":"flex"},attrs:{"id":"map_footer_left"}},[_c('a',{staticStyle:{"margin-left":"5px","align-self":"center"},attrs:{"href":"https://g3wsuite.it/","target":"_blank","title":_vm.version}},[_c('img',{attrs:{"height":"15","src":"/static/client/images/g3wsuite_logo.png","alt":""}})])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"},attrs:{"id":"map_footer_right"}},[(_vm.mouse.visible && _vm.mouse.switch_icon && !_vm.isMobile())?_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:(_vm.mouse.tooltip),expression:"mouse.tooltip",arg:"top",modifiers:{"create":true}}],attrs:{"id":"switch-mouse-coordinate"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.switchMapsCoordinateTo4326.apply(null, arguments)}}},[_c('span',{staticClass:"skin-color-dark",class:_vm.$fa('mouse'),staticStyle:{"caret-color":"rgba(0,0,0,0)"}})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mouse.visible),expression:"mouse.visible"}],attrs:{"id":"mouse-position-control"}}),_vm._v(" "),_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sdk.tooltips.copy_map_extent_url'),expression:"'sdk.tooltips.copy_map_extent_url'",arg:"top",modifiers:{"create":true}}],class:_vm.$fa('share-alt') + ' skin-color-dark',attrs:{"id":"permalink"},on:{"click":function($event){$event.stopPropagation();return _vm.showEmbedModal.apply(null, arguments)}}}),_vm._v(" "),_c('div',{attrs:{"id":"scale-control"}}),_vm._v(" "),(_vm.showmapunits)?_c('div',{attrs:{"id":"scale-line-units"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapunit),expression:"mapunit"}],staticClass:"skin-color-dark",staticStyle:{"padding":"5px 2px","font-weight":"bold","border":"0","cursor":"pointer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mapunit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.service.state.mapunits),function(unit){return _c('option',{directives:[{name:"t",rawName:"v-t",value:(("sdk.mapcontrols.scaleline.units." + unit)),expression:"`sdk.mapcontrols.scaleline.units.${unit}`"}],staticStyle:{"font-weight":"bold"},domProps:{"value":unit,"selected":_vm.mapunit === unit}})}),0)]):_vm._e()])])],2)}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('div',{attrs:{"id":"marker"}})])}]

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-17585370_0", { source: "#marker[data-v-17585370]{width:15px;height:15px;border:2px solid #ff0;border-radius:10px;background-color:#ff0;opacity:.8}.g3w-map-controls-left-bottom[data-v-17585370]{position:absolute;bottom:75px;left:10px;z-index:1}#g3w-map-info[data-v-17585370]{position:absolute;top:60px;left:5px;font-weight:700;z-index:100;background:rgba(255,255,255,.6);padding:5px;border-radius:3px}#g3w-maps[data-v-17585370]{position:relative;width:100%;height:100%}.g3w-map[data-v-17585370]{position:absolute;width:100%;height:100%}.g3w-map.show[data-v-17585370]{display:block}.g3w-map.hide[data-v-17585370]{display:none}#map_footer[data-v-17585370]{position:absolute;bottom:0;height:30px;width:100%;display:flex;justify-content:space-between;background-color:rgba(255,255,255,.7)}#permalink[data-v-17585370]{font-weight:700;font-size:1.2em;padding:8px 5px 0 5px;cursor:pointer;background-color:#eee}#switch-mouse-coordinate[data-v-17585370]{display:flex;height:100%;margin-left:8px;align-items:center;cursor:pointer}#switch-mouse-coordinate span[data-v-17585370]{padding:3px 5px 0 3px}#map_footer_right[data-v-17585370]{flex-shrink:0}.drop-area[data-v-17585370]:not([hidden]){display:flex}.drop-area[data-v-17585370]{justify-content:center;align-items:center;width:100%;height:100%;color:#fff;font-size:4em;position:absolute;z-index:100;background-color:var(--bgcolor);pointer-events:none}.drop-area[data-v-17585370]::before{border:5px dashed #fff;content:\"\";bottom:60px;left:60px;position:absolute;right:60px;top:60px}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-17585370"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Map.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__